import { Dialog as MuiDialog } from '@mui/material';
import { dialogClasses } from './Dialog';
import { shouldNotForwardProps } from '../../helpers';
import { styled } from '../muiReexports';
export const MuiDialogStyled = styled(MuiDialog, shouldNotForwardProps('fullHeight'))(({ fullHeight }) => ({
    ...(fullHeight && {
        [`.${dialogClasses.paper}`]: {
            height: '100%',
        },
    }),
}));
